import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import onClickOutside from "react-onclickoutside";

import DropdownButton from "../Global/Dropdowns/DropdownButton";
import DropdownSection from "../Global/Dropdowns/DropdownSection";


const SharePermissionDropdown = ({ accessor, active, permissionOptions, onAccessorClick, onPermissionClick }) => {

  SharePermissionDropdown.onClickOutside = () => {
    // unset active value and collapse dropdown
    onAccessorClick(null);
  };

  const dropdownClick = (dropdownOpen, accessorId) => {
    if (dropdownOpen) {
      // unset active value and collapse dropdown
      onAccessorClick(null);
    } else {
      // expand dropdown
      onAccessorClick(accessorId);
    }
  };

  const dropdownContainerClasses = classNames(
    `dropdown`,
    `dropdown--with-arrow`,
    `dropdown--with-label`,
    // ignore outside clicks within the dropdown itself
    `ignore-react-onclickoutside`,
  );

  const dropdownClasses = classNames(
    `dropdown__menu`,
    `dropdown__menu--xs`,
    `dropdown__menu--right`, {
      'dropdown__menu--active': active,
    });

  return (
    <div className={dropdownContainerClasses}>
      <DropdownButton onClick={() => dropdownClick(active, accessor.id)} label={permissionOptions.default.label} />
      <div className={dropdownClasses}>
        {permissionOptions.options.map(option => (
          <DropdownSection key={option.value}>
            <button
              className="dropdown-link faux-btn"
              onClick={() => onPermissionClick(accessor, option.value)}
            >
              {option.label}
            </button>
          </DropdownSection>
        ))}
      </div>
    </div>
  );
};

SharePermissionDropdown.propTypes = {
  accessor: PropTypes.object,
  active: PropTypes.bool.isRequired,
  permissionOptions: PropTypes.object,
  onAccessorClick: PropTypes.func.isRequired,
  onPermissionClick: PropTypes.func.isRequired,
};

const clickOutsideConfig = {
  handleClickOutside: () => SharePermissionDropdown.onClickOutside,
};

export default onClickOutside(SharePermissionDropdown, clickOutsideConfig);



// WEBPACK FOOTER //
// ./library/app/components/Folders/SharePermissionDropdown.js